import { SET_SESSIONS_DATA } from "../actions";

export const setSessionsData = (payload = {}) => {
  return {
    type: SET_SESSIONS_DATA,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/store/actionCreators/sesssionsData.js